import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListWrapper from 'components/templates/Wrappers/Headers/ListWrapper/ListWrapper';

const StyledCollectionServicesSectionPanelContent = styled(ListWrapper)`
  &.CollectionServicesSectionPanelContent {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .Profile {
      flex-grow: 1;
      min-height: unset;
      padding-top: ${props => props.theme.spacing(1)};
      padding-bottom: ${props => props.theme.spacing(2)};
    }

    .ListWrapper-content {
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
  }
  
  ${ComponentStyles}
`;

StyledCollectionServicesSectionPanelContent.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionServicesSectionPanelContent;
